import React, { useState } from "react";
import { Loader2, Sparkles, Trash2 } from "lucide-react";
import { useAiGuides, postJson } from "../../lib/growthApi";
import { csuiteAuth } from "../../lib/csuiteApi";

export function AdminAiGuides() {
  const items = useAiGuides();
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [removed, setRemoved] = useState([]);
  const generate = async () => {
    setBusy(true); setMsg("");
    try { await postJson("/admin/guides/generate", {}, true); setMsg("Writing a new guide now. It appears here and on /guides in about a minute."); setTimeout(() => window.location.reload(), 75000); }
    catch (e) { setMsg(e.message); } finally { setBusy(false); }
  };
  const remove = async (slug) => {
    if (!window.confirm("Unpublish this guide?")) return;
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/guides/${slug}`, { method: "DELETE", headers: { Authorization: `Bearer ${csuiteAuth.getToken()}` } });
    if (r.ok) setRemoved((x) => [...x, slug]);
  };
  const live = items.filter((g) => !removed.includes(g.slug));
  return (
    <section className="mt-10 p-5 rounded-md bg-white border" style={{ borderColor: "#F0D3D8" }} data-testid="admin-ai-guides">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h2 className="font-mono text-[11px] uppercase tracking-[0.2em]" style={{ color: "#7A1F2B" }}>Weekly AI guides</h2>
          <p className="text-xs text-zinc-600 mt-1">A new guide publishes automatically every Monday at 07:00 UTC. You get an email each time.</p>
        </div>
        <button onClick={generate} disabled={busy} className="px-3 py-2 rounded-sm text-white text-xs font-semibold inline-flex items-center gap-1.5" style={{ background: "#7A1F2B" }} data-testid="admin-ai-guides-generate">
          {busy ? <Loader2 size={13} className="animate-spin"/> : <Sparkles size={13}/>} Write one now
        </button>
      </div>
      {msg && <p className="mt-2 text-xs text-zinc-700" data-testid="admin-ai-guides-msg">{msg}</p>}
      <ul className="mt-3 divide-y" style={{ borderColor: "#F0D3D8" }}>
        {live.length === 0 && <li className="py-2 text-sm text-zinc-500">No AI guides yet.</li>}
        {live.map((g) => (
          <li key={g.slug} className="py-2 flex items-center justify-between gap-3 text-sm" data-testid={`admin-ai-guide-${g.slug}`}>
            <a href={`/guides/${g.slug}`} className="underline">{g.title}</a>
            <span className="flex items-center gap-3 shrink-0 text-xs text-zinc-500">{(g.published_at || "").slice(0, 10)}
              <button onClick={() => remove(g.slug)} className="text-red-600" data-testid={`admin-ai-guide-delete-${g.slug}`}><Trash2 size={14}/></button>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
